import { IFlexProps } from './types'
import generateBreakpointStyles from '@/utils/generateBreakpointStyles'
import styles from './flex.module.scss'
import clsx from 'clsx'

const Flex = ({
  children,
  align,
  justify,
  wrap,
  spacing = 0,
  xSpacing,
  ySpacing,
  direction,
  width,
  maxWidth,
  minWidth,
  height,
  maxHeight,
  minHeight,
  grow,
  shrink,
  ...props
}: IFlexProps) => {
  const directionStyles = generateBreakpointStyles(direction, `direction`)
  const justifyStyles = generateBreakpointStyles(justify, `justify`)
  const alignStyles = generateBreakpointStyles(align, `align`)
  const spacingStylesX = generateBreakpointStyles(spacing, `xSpacing`)
  const spacingStylesY = generateBreakpointStyles(spacing, `ySpacing`)
  const xSpacingStyles = generateBreakpointStyles(xSpacing, `xSpacing`)
  const ySpacingStyles = generateBreakpointStyles(ySpacing, `ySpacing`)
  const wrapStyles = generateBreakpointStyles(wrap, `wrap`)
  const growStyles = generateBreakpointStyles(grow, `grow`)
  const shrinkStyles = generateBreakpointStyles(shrink, `shrink`, true)
  const widthStyles = generateBreakpointStyles(width, `width`)
  const maxWidthStyles = generateBreakpointStyles(maxWidth, `maxWidth`)
  const minWidthStyles = generateBreakpointStyles(minWidth, `minWidth`)
  const heightStyles = generateBreakpointStyles(height, `height`)
  const maxHeightStyles = generateBreakpointStyles(maxHeight, `maxHeight`)
  const minHeightStyles = generateBreakpointStyles(minHeight, `minHeight`)

  const scopedStyles = {
    ...alignStyles,
    ...justifyStyles,
    ...wrapStyles,
    ...spacingStylesX,
    ...spacingStylesY,
    ...xSpacingStyles,
    ...ySpacingStyles,
    ...directionStyles,
    ...growStyles,
    ...shrinkStyles,
    ...widthStyles,
    ...maxWidthStyles,
    ...minWidthStyles,
    ...heightStyles,
    ...maxHeightStyles,
    ...minHeightStyles,
  }

  return (
    <div
      data-testid="mui-flex"
      style={scopedStyles}
      className={clsx(styles.flexContainer)}
      {...props}
    >
      {children}
    </div>
  )
}

export default Flex
